"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    blue10: '#d6ebff',
    blue20: '#add6ff',
    blue30: '#7cbaf7',
    blue40: '#4d9ceb',
    blueBase: '#1f78d1',
    blue60: '#205ea1',
    blue70: '#184b7a',
    blue80: '#063752',
    blue90: '#102228',
    green10: '#dff4ef',
    green20: '#a0ebd9',
    green30: '#4eccae',
    green40: '#11a885',
    greenBase: '#038768',
    green60: '#0b785f',
    green70: '#0d634f',
    green80: '#084f3e',
    green90: '#123b31',
    red10: '#ffd9e2',
    red20: '#ffabbe',
    red30: '#ff698c',
    red40: '#e54067',
    redBase: '#ce2950',
    red60: '#b02041',
    red70: '#8c122f',
    red80: '#66051c',
    red90: '#450010',
    orange10: '#ffe8d6',
    orange20: '#ffd0b0',
    orange30: '#ffb685',
    orange40: '#ff9b59',
    orangeBase: '#f18533',
    orange60: '#c76725',
    orange70: '#a84f13',
    orange80: '#7d3b0e',
    orange90: '#522613',
    purple10: '#f3def2',
    purple20: '#f0bded',
    purple30: '#db8ad7',
    purple40: '#cc66c7',
    purpleBase: '#b53aaf',
    purple60: '#912e8c',
    purple70: '#6d2369',
    purple80: '#481746',
    purple90: '#321538',
    gray10: '#f5f6f7',
    gray20: '#eaecee',
    gray30: '#dee0e2',
    gray40: '#d6d8da',
    gray50: '#aeb1b4',
    gray60: '#8e9193',
    gray70: '#636566',
    gray80: '#2c2d2e',
    darkMode10: '#88979d',
    darkMode20: '#697a81',
    darkMode30: '#49585e',
    darkMode40: '#35444a',
    darkMode50: '#1e2c31',
    darkMode60: '#102228',
    darkMode70: '#02171e',
    darkMode80: '#010c10',
    black: '#000',
    darkBlue: '#102228',
    white: '#fff',
    yellow: '#fdca29',
    green: '#193A30;',
};
